var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-secondary btn-size-medium",on:{"click":_vm.confirmRestartExperience}},[_vm._v("\n  Restart this Experience\n")])}
var staticRenderFns = []

export { render, staticRenderFns }